import React, { useState } from 'react';
import { motion } from 'framer-motion';
import utils from "../../services/utils";
import IconProfile from '../../style/icons/profile-user.svg';
import managedata from "../../services/managedata";
import managecookies from "../../services/managecookies";
import '../../style/css/profile2026.css';

// Profile edit. Passwordless auth → no password fields; a phone change is
// confirmed with an OTP (editMyPhone → verifyNewPhone), a name change saves directly.
const GeneralProfile = ({ userData }) => {
    const [step, setStep] = useState('edit');
    const [fName, setFname] = useState(userData.privateName);
    const [lName, setLName] = useState(userData.lastName);
    const [phone] = useState(userData.phone);
    const [newPhone, setNewPhone] = useState(userData.phone);
    const [verificationCode, setVerificationCode] = useState('');

    const auth = () => ({ key: utils.getToken(), businessToken: utils.getBusToken() });

    const editLocalUser = (type) => {
        if (type === 'name') { userData.privateName = fName; userData.lastName = lName; }
        else if (type === 'phone') { userData.phone = newPhone; }
        managecookies.setCookie('userData', JSON.stringify(userData), 8);
    };

    const updateAll = () => {
        // Update the local cookie only AFTER the server confirms the change.
        managedata.sendData({
            authentication: auth(),
            data: { privateName: fName, lastName: lName },
            type: { act: 'editMyName' },
        }, undefined, () => editLocalUser('name'));
    };

    const onSave = () => {
        if (newPhone === phone) {
            updateAll();
            return;
        }
        // Only prompt for the OTP once the phone-change request actually succeeds.
        managedata.sendData({
            authentication: auth(),
            data: { phone: newPhone, firstOrLastName: lName },
            type: { act: 'editMyPhone' },
        }, undefined, () => setStep('verify'));
    };

    const handleVerify = () => {
        managedata.sendData({
            authentication: auth(),
            data: { otpCode: verificationCode },
            type: { act: 'verifyNewPhone' },
        }, false, () => { editLocalUser('phone'); updateAll(); });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
        >
            <div className="pf-card">
                <h2 className="pf-title">{utils.useLang('EDIT_USER')}</h2>

                {step === 'edit' && (
                    <>
                        <div className="pf-avatar">
                            <img src={IconProfile} alt="פרופיל" />
                        </div>
                        <div className="pf-grid">
                            <div className="pf-field">
                                <label className="pf-label">{utils.useLang('FIRST_NAME')}</label>
                                <input className="pf-input" value={fName} onChange={(e) => setFname(e.target.value)} />
                            </div>
                            <div className="pf-field">
                                <label className="pf-label">{utils.useLang('LAST_NAME')}</label>
                                <input className="pf-input" value={lName} onChange={(e) => setLName(e.target.value)} />
                            </div>
                            <div className="pf-field pf-full">
                                <label className="pf-label">{utils.useLang('EMAIL')}</label>
                                <input className="pf-input" type="email" disabled value={userData.email || ''} dir="ltr" />
                            </div>
                            <div className="pf-field pf-full">
                                <label className="pf-label">{utils.useLang('PHONE_NUMBER')}</label>
                                <input className="pf-input" value={newPhone} onChange={(e) => setNewPhone(e.target.value)} dir="ltr" />
                            </div>
                        </div>
                        <div className="pf-actions">
                            <button className="pf-btn pf-btn--primary" onClick={onSave}>
                                {utils.useLang('SAVE_DETAILS')}
                            </button>
                        </div>
                    </>
                )}

                {step === 'verify' && (
                    <div className="pf-verify">
                        <p className="pf-verify-note">{utils.useLang('ENTER_CODE_SMS')}</p>
                        <input
                            className="pf-code" type="text" maxLength={6} dir="ltr"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                        />
                        <div className="pf-actions">
                            <button className="pf-btn pf-btn--ghost" onClick={() => setStep('edit')}>
                                {utils.useLang('BACK')}
                            </button>
                            <button className="pf-btn pf-btn--primary" onClick={handleVerify}>
                                {utils.useLang('SEND')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default GeneralProfile;
